/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

const styles = (theme) => {
  const secondaryColor = theme.palette.secondary.main;
  const secondaryColorLight = theme.palette.secondary.light;
  const infoColorLight = theme.palette.info.light;

  const cardGeneral = {
    borderRadius: "10px",
    backgroundColor: "white",
    border: `2px solid ${secondaryColorLight}`,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "auto",
    cursor: "pointer",
    overflow: "hidden",
  };

  return {
    cardPaper: {
      backgroundColor: "#00000060",
      padding: 0,
    },

    cardRoot: { height: "100%" },

    transition__transition: {
      transition: "@transition",
      WebkitTransition: "@transition",
      MozTransition: "@transition",
      MsTransition: "@transition",
      OTransition: "@transition",
    },
    // .transition(@transition) {
    //   transition:         @transition;
    // 	-webkit-transition: @transition;
    // 	-moz-transition:    @transition;
    // 	-ms-transition:     @transition;
    // 	-o-transition:      @transition;
    // }

    flipCard: {
      height: "100%",
      position: "relative",
    },

    perspective: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",

      perspective: "1000px",
      transformStyle: "preserve-3d",
      overflow: "hidden",
    },

    cardWrap: {
      transformStyle: "preserve-3d",
      transition: "all ease-out 0.8s",
    },

    cardFront: {
      ...cardGeneral,
      zIndex: 20, // make sure the cardFront view is above cardBack
    },

    cardBack: {
      ...cardGeneral,
      zIndex: 10,
      transform: "rotate(180deg) translateZ(-5px)",
    },

    cardContent: {
      height: "100%",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
    },

    cardBackContent: {
      height: "100%",
      transform: "rotateY(180deg)",
    },

    cardFooter: {
      width: "100%",
      display: "flex",
      "@media (min-width: 768px)": {
        flexDirection: "row",
        justifyContent: "space-between",
        "@media (min-width: 1440px)": {
          fontSize: "1rem",
        },
        fontSize: "0.75rem",
      },
      flexDirection: "column",
      alignItems: "center",

      fontSize: "0.5rem",
      fontFamily: "Open Sans",
      fontWeight: 700,
      lineHeight: "150%",
      padding: "0 1rem",
      color: "#422550",
      position: "absolute",
      bottom: "5px",
    },

    cardPageNum: {
      color: infoColorLight,
    },

    cardActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0.5rem",
      margin: "0.5rem 0",
      backgroundColor: "transparent",
      color: "white",
      fontWeight: 700,
    },

    btn: {
      backgroundColor: secondaryColorLight,
      color: "white",
      "&:hover": {
        backgroundColor: secondaryColor,
      },
    },

    blankPage: {
      width: "100%",
      margin: "5rem auto",
      textAlign: "center",
      fontSize: "2rem",
      color: infoColorLight,
    },

    flip: {
      transform: "rotateX(180deg)",
    },
  };
};

export default styles;

// title: {
//   content: "",
//   height: "5px",
//   width: "80%",
//   position: "absolute",
//   right: 0,
//   left: 0,
//   top: 0,
//   bottom: "-70%",
//   margin: "auto",
//   background: secondaryColorDark,
//   transform: "rotateX(-80deg)",
// },
